// Format ngày tháng
export const formatDate = (dateString: string): string => {
  if (!dateString) return 'N/A';
  
  const date = new Date(dateString);
  return date.toLocaleDateString('vi-VN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
};

// Format tiền tệ
export const formatCurrency = (amount: number): string => {
  if (amount === null || amount === undefined) return 'N/A';
  
  return new Intl.NumberFormat('vi-VN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

// Format số lượng
export const formatQuantity = (quantity: number, unit: string = ''): string => {
  if (quantity === null || quantity === undefined) return 'N/A';
  
  const formatted = new Intl.NumberFormat('vi-VN').format(quantity);
  return unit ? `${formatted} ${unit}` : formatted;
};

// Tính số ngày còn lại đến hạn sử dụng
export const getDaysUntilExpiry = (expiryDate: string): number => {
  const expiry = new Date(expiryDate);
  const today = new Date();
  return Math.ceil((expiry.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
};

// Lấy màu sắc cho trạng thái hạn sử dụng
export const getExpiryColor = (daysUntilExpiry: number): string => {
  if (daysUntilExpiry <= 30) return 'red';
  if (daysUntilExpiry <= 90) return 'orange';
  return 'green';
}; 